import { Outlet, Link, useLocation } from "react-router-dom";
import { Terminal, Wallet, Code2, Activity, Cpu, Network, BarChart3, PieChart, History, MessageSquare, Hammer, Brain } from "lucide-react";
import { useState, useEffect } from "react";

const baseNavItems = [
  { path: "/", label: "DASHBOARD", icon: Activity },
  { path: "/portfolio", label: "PORTFOLIO", icon: PieChart },
  { path: "/markets", label: "MARKETS", icon: BarChart3 },
  { path: "/bot", label: "BOT CONTROL", icon: Cpu },
  { path: "/crew", label: "CREW AI", icon: Network },
  { path: "/ai-quant", label: "AI QUANT LAB", icon: Brain },
  { path: "/strategies", label: "STRATEGIES", icon: MessageSquare },
  { path: "/backtest", label: "BACKTEST", icon: History },
  { path: "/wallet", label: "WALLET", icon: Wallet },
  { path: "/strategy", label: "STRATEGY EDITOR", icon: Code2 },
];

export default function TerminalLayout() {
  const location = useLocation();
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const adminKey = localStorage.getItem("alphabot_admin");
    if (adminKey === "enabled") setIsAdmin(true);
  }, []);

  const navItems = isAdmin
    ? [...baseNavItems, { path: "/builder", label: "BUILDER (ADMIN)", icon: Hammer }]
    : baseNavItems;

  return (
    <div className="flex h-screen bg-black text-green-400 font-mono">
      {/* Sidebar */}
      <aside className="w-56 border-r border-terminal-border bg-[#0c0c0c] flex flex-col">
        <div className="p-4 border-b border-terminal-border">
          <div className="flex items-center gap-2 text-terminal-accent">
            <Terminal size={20} />
            <span className="font-bold text-lg tracking-tight glow-text">AlphaBot</span>
          </div>
          <div className="text-[10px] text-gray-600 mt-1">POLYMARKET TERMINAL v2.0</div>
        </div>

        <nav className="flex-1 py-4 overflow-auto">
          {navItems.map((item) => {
            const isActive = location.pathname === item.path;
            const Icon = item.icon;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center gap-3 px-4 py-3 mx-2 rounded text-sm transition-all ${
                  isActive
                    ? "bg-terminal-fg/10 text-terminal-fg border-l-2 border-terminal-fg"
                    : "text-gray-500 hover:text-terminal-fg hover:bg-white/5"
                }`}
              >
                <Icon size={16} />
                <span>{item.label}</span>
              </Link>
            );
          })}
        </nav>

        <div className="p-3 border-t border-terminal-border">
          {!isAdmin && (
            <div className="text-[10px] text-gray-600 mb-2">
              <button
                onClick={() => {
                  const key = prompt("Enter admin key to enable builder page:");
                  if (key === "alphabot2024") {
                    localStorage.setItem("alphabot_admin", "enabled");
                    setIsAdmin(true);
                  }
                }}
                className="text-gray-600 hover:text-gray-400 underline cursor-pointer"
              >
                Admin login
              </button>
            </div>
          )}
          <div className="text-[10px] text-gray-600">
            <div className="flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" />
              <span>SYSTEM ONLINE</span>
            </div>
            <div className="mt-1">LATENCY: 47ms</div>
          </div>
        </div>
      </aside>

      {/* Main content */}
      <main className="flex-1 overflow-auto bg-[#0a0a0a]">
        <Outlet />
      </main>
    </div>
  );
}
